"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const apiUrl = '/api';
exports.api = {
    manufactures: `${apiUrl}/manufactures`,
    catalog: `${apiUrl}/catalog`,
    tokenCheck: `${apiUrl}/token/check`,
    writeCatalog: `${apiUrl}/write/catalog`
};
//# sourceMappingURL=api.js.map